import { Button, HeadlinerGradientSquare, Link } from '@sparemin/blockhead';
import InfoCard from 'components/InfoCard';
import React from 'react';
import { COMING_SOON_BADGE } from './constants';
import * as S from './styles';
import { PlacementCardProps } from './types';

const HeadlinerCard: React.FC<PlacementCardProps> = ({
  isComingSoon,
  onPress,
}) => (
  <S.Card $isDisabled={isComingSoon}>
    <S.HeadlinerCardContainer>
      <InfoCard.Image>
        <HeadlinerGradientSquare width="80px" height="80px" />
      </InfoCard.Image>

      <InfoCard.Contents
        badge={isComingSoon ? COMING_SOON_BADGE : 'Lower price'}
        heading="Within Headliner’s app"
        subheading={
          <>
            A great value for podcasts with general genres, such as True Crime
            or Comedy, because our apps provide great exposure at a lower price
            (
            <Link
              href="https://learn.headliner.app/hc/en-us/articles/22688870315031-Podcast-Promo-Internal-Widget"
              target="_blank"
            >
              learn more
            </Link>
            ).
          </>
        }
      >
        <S.ButtonContainer>
          <Button fluid isDisabled={isComingSoon} onPress={onPress}>
            Select this option
          </Button>
        </S.ButtonContainer>
      </InfoCard.Contents>
    </S.HeadlinerCardContainer>
  </S.Card>
);

export default HeadlinerCard;
